import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  headerCard: {
    width: '100%',
    '& .ant-card-body': {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  },
  treatmentCard: {
    '& .ant-card-body': {
      padding: 0
    }
  },
  treatmentContent: {
    padding: '24px 24px'
  }
}))
